import { FC, useMemo } from "react";
import Select, { SingleValue } from "react-select";

import { IDropdownItem } from "@ryde/shared";

import {
  getRideDocksEditableSelectClassNames,
  getRideDocksEditableSelectStyles,
} from "./ride-docks-editable-dropdown-select.utils";

export interface IRideEditableDocksDropdownSelectProps {
  options: IDropdownItem[];
  selectedValue: number | undefined;
  onChange: (newValue: SingleValue<IDropdownItem>) => void;
}

export const RideEditableDocksDropdownSelect: FC<
  IRideEditableDocksDropdownSelectProps
> = ({ options, selectedValue, onChange }) => {
  const classNames = useMemo(() => getRideDocksEditableSelectClassNames(), []);
  const styles = useMemo(
    () =>
      getRideDocksEditableSelectStyles({
        selectedValue,
      }),
    [selectedValue],
  );

  return (
    <Select
      // eslint-disable-next-line jsx-a11y-x/no-autofocus -- intentional: focus the field when opened by user action
      autoFocus
      classNames={classNames}
      styles={styles}
      backspaceRemovesValue={false}
      data-e2e="editable-dropdown-bound"
      components={{
        DropdownIndicator: null,
        IndicatorSeparator: null,
      }}
      controlShouldRenderValue={false}
      isClearable
      menuIsOpen
      options={options}
      onChange={onChange}
      tabSelectsValue={false}
    />
  );
};
